import moment from "moment";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import {
  actionDownload,
  resetDownloadPolicyResponse,
} from "../../dashboard/store";
import toast from "react-hot-toast";
import {
  TOAST_DURATION,
  TOAST_ERROR_COLOR,
  TOAST_POSITION,
} from "../../../../../common/app_constant";
import { useDispatch, useSelector } from "react-redux";
import { getLocalStorageItem } from "../../../../../utils";

const PolicyDetails = () => {
  const location = useLocation();
  // const initialData = location.state?.data;
  const [initialData, setInitialData] = useState(null);
  const { setValue, control, watch } = useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const watchBizType = watch("biz_type");
  const [docStatus, setDocStatus] = useState(null);
  const [document, setDocument] = useState([]);
  const [employeeName, setEmployeeName] = useState(null);
  const [role, setRole] = useState(null);

  const { downloadPolicy } = useSelector((state) => ({
    ...state.dashboardStore,
  }));

  useEffect(() => {
    setInitialData(JSON.parse(localStorage.getItem("detailsData")));
  });

  useEffect(() => {
    setRole(getLocalStorageItem("next"));
    if (initialData && initialData !== null) {
      Object.keys(initialData).forEach((key) => {
        setValue(key, initialData[key]);
      });
      setDocStatus(initialData?.policy_doc_status);
      setDocument(initialData?.documents);
      if (
        initialData?.userDetails !== null &&
        initialData?.userDetails?.full_name !== null
      ) {
        setEmployeeName(initialData?.userDetails?.full_name);
      }
    }
  }, [initialData]);

  useEffect(() => {
    if (downloadPolicy !== null) {
      dispatch(resetDownloadPolicyResponse());
      if (downloadPolicy.status === true) {
        if (downloadPolicy.status === true && Array.isArray(downloadPolicy.data.urls)) {
          downloadPolicy.data.urls.forEach(item => {
            if (item.url) {
              window.open(item.url, '_blank');
            }
          });
        }
      } else {
        switch (downloadPolicy.status_code) {
          case 400:
            toast.error(downloadPolicy.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          case 401:
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          default:
        }
      }
    }
  }, [downloadPolicy]);

  return (
    <>
      <section className="pb-5">
        <div className="card mb-5 mt-6">
          <div className="card-header bg-primary  d-flex justify-content-between">
            Policy Details
            {/* <h6
              className="text-white mb-0 cursor-pointer"
              onClick={(event) => {
                event.preventDefault();
                navigate(-1);
              }}
            >
              {" "}
              Back
            </h6> */}
          </div>
          <div className="card-body">
            <form noValidate autoComplete="Off">
              <div className="form-body">
                <div className="row mb-3">
                  {/* Vehical Details */}
                  <div className="col-12 border-bottom mb-2">
                    <h6 className="text-primary">Vehicle Details</h6>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">Biz Type</label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="biz_type"
                          name="biz_type"
                          render={({ field }) => {
                            return (
                              <label
                                id="biz_type_label"
                                className="border-0 fw-bold"
                              >
                                {field.value}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">Employee Name</label>
                      <div className="my-1">
                        <label id="employee_label" className="border-0 fw-bold">
                          {employeeName && employeeName !== null
                            ? employeeName
                            : "-"}
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">Customer Group</label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="customer_group"
                          name="customer_group"
                          render={({ field }) => {
                            return (
                              <label
                                id="customer_group_label"
                                className="border-0 fw-bold"
                              >
                                {field.value}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      {/* (Customer Name) */}
                      <label className="label-control">Insured Name</label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="insured_name"
                          name="insured_name"
                          render={({ field }) => {
                            return (
                              <label
                                id="insured_name_label"
                                className="border-0 fw-bold"
                              >
                                {field.value}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {watchBizType !== "New" && (
                    <div className="col-12 col-md-3 mb-3">
                      <div className="form-group">
                        <label className="label-control">
                          Previous Policy No
                        </label>
                        <div className="my-1">
                          <Controller
                            className="form-control"
                            control={control}
                            id="previous_policy_no"
                            name="previous_policy_no"
                            render={({ field }) => {
                              return (
                                <label
                                  id="previous_policy_no_label"
                                  className="border-0 fw-bold"
                                >
                                  {field.value &&
                                    field.value !== null &&
                                    field.value !== "null"
                                    ? field.value
                                    : "-"}
                                </label>
                              );
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">Product Name</label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="product_name"
                          name="product_name"
                          render={({ field }) => {
                            return (
                              <label
                                id="product_name_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">Policy Type</label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="policy_type"
                          name="policy_type"
                          render={({ field }) => {
                            return (
                              <label
                                id="policy_type_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">Policy Sub Type</label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="sub_type"
                          name="sub_type"
                          render={({ field }) => {
                            return (
                              <label
                                id="sub_type"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div> */}
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Policy Number Received Status
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="policy_received_status"
                          name="policy_received_status"
                          render={({ field }) => {
                            return (
                              <label
                                id="policy_received_status_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">Policy No</label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="policy_no"
                          name="policy_no"
                          render={({ field }) => {
                            return (
                              <label
                                id="policy_no_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">Insurer Name</label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="insurer_name"
                          name="insurer_name"
                          render={({ field }) => {
                            return (
                              <label
                                id="insurer_name_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div class="form-group has-search">
                      <label for="policy_start_date" class="form-label">
                        Policy Start Date
                      </label>
                      {/* <span class="fa fa-calendar form-control-feedback"></span> */}
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="policy_start_date"
                          name="policy_start_date"
                          render={({ field }) => {
                            return (
                              <label
                                id="policy_start_date_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? moment(field.value).format("DD-MM-YYYY")
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div class="form-group has-search">
                      <label for="policy_expiry_date" class="form-label">
                        Policy Expiry Date
                      </label>
                      {/* <span class="fa fa-calendar form-control-feedback"></span> */}
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="policy_expiry_date"
                          name="policy_expiry_date"
                          render={({ field }) => {
                            return (
                              <label
                                id="policy_expiry_date_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? moment(field.value).format("DD-MM-YYYY")
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div class="form-group has-search">
                      <label for="tp_start_date" class="form-label">
                        TP Start Date
                      </label>
                      {/* <span class="fa fa-calendar form-control-feedback"></span> */}
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="tp_start_date"
                          name="tp_start_date"
                          render={({ field }) => {
                            return (
                              <label
                                id="tp_start_date_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? moment(field.value).format("DD-MM-YYYY")
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div class="form-group has-search">
                      <label for="tp_expiry_date" class="form-label">
                        TP Expiry Date
                      </label>
                      {/* <span class="fa fa-calendar form-control-feedback"></span> */}
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="tp_expiry_date"
                          name="tp_expiry_date"
                          render={({ field }) => {
                            return (
                              <label
                                id="tp_expiry_date_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? moment(field.value).format("DD-MM-YYYY")
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label for="rto_details" className="label-control">
                        RTO Details
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="rto_details"
                          name="rto_details"
                          render={({ field }) => {
                            return (
                              <label
                                id="rto_details_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label for="vehicle_no" className="label-control">
                        Vehicle Number(Reg. No.)
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="vehicle_no"
                          name="vehicle_no"
                          render={({ field }) => {
                            return (
                              <label
                                id="vehicle_no_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label for="vehicle_make" className="label-control">
                        Vehicle Make
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="vehicle_make"
                          name="vehicle_make"
                          render={({ field }) => {
                            return (
                              <label
                                id="vehicle_make_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label for="vehicle_model" className="label-control">
                        Vehicle Model
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="vehicle_model"
                          name="vehicle_model"
                          render={({ field }) => {
                            return (
                              <label
                                id="vehicle_model_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label for="vehicle_variant" className="label-control">
                        Vehicle Variant
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="vehicle_variant"
                          name="vehicle_variant"
                          render={({ field }) => {
                            return (
                              <label
                                id="vehicle_variant_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label for="vehicle_type" className="label-control">
                        Vehicle Type
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="vehicle_type"
                          name="vehicle_type"
                          render={({ field }) => {
                            return (
                              <label
                                id="vehicle_type_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label for="seating_capacity" className="label-control">
                        Seating Capacity
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="seating_capacity"
                          name="seating_capacity"
                          render={({ field }) => {
                            return (
                              <label
                                id="seating_capacity_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div class="form-group has-search">
                      <label for="registration_date" class="form-label">
                        Registration Date
                      </label>
                      {/* <span class="fa fa-calendar form-control-feedback"></span> */}
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="registration_date"
                          name="registration_date"
                          render={({ field }) => {
                            return (
                              <label
                                id="registration_date_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? moment(field.value).format("DD-MM-YYYY")
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label for="fuel_type" className="label-control">
                        Fuel Type
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="fuel_type"
                          name="fuel_type"
                          render={({ field }) => {
                            return (
                              <label
                                id="fuel_type_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label for="cubic_capacity" className="label-control">
                        Cubic capacity (CC)
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="cubic_capacity"
                          name="cubic_capacity"
                          render={({ field }) => {
                            return (
                              <label
                                id="cubic_capacity_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label for="engine_no" className="label-control">
                        Vehicle Engine No
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="engine_no"
                          name="engine_no"
                          render={({ field }) => {
                            return (
                              <label
                                id="engine_no_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label for="chassis" className="label-control">
                        Chassis Number
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="chassis"
                          name="chassis"
                          render={({ field }) => {
                            return (
                              <label
                                id="chassis_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label for="claims" className="label-control">
                        Claims History
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="claims"
                          name="claims"
                          render={({ field }) => {
                            return (
                              <label
                                id="claims_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label for="ncb_current_year" className="label-control">
                        Current NCB %
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="ncb_current_year"
                          name="ncb_current_year"
                          render={({ field }) => {
                            return (
                              <label
                                id="ncb_current_year_label"
                                className="border-0 fw-bold"
                              >
                                {field.value !== null && field.value !== "null"
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Price Of Vehicle Without ( Insurance & TCS )
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="price_of_vehicle_without_insurance_and_tcs"
                          name="price_of_vehicle_without_insurance_and_tcs"
                          render={({ field }) => {
                            return (
                              <label
                                id="price_of_vehicle_without_insurance_and_tcs_label"
                                className="border-0 fw-bold"
                              >
                                {field.value !== null && field.value !== "null"
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>


                    </div>
                  </div>
                  {/* Premium Details */}
                  <div className="col-12 border-bottom mb-2">
                    <h6 className="text-primary">Premium Details</h6>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label for="sum_insured" className="label-control">
                        IDV
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="sum_insured"
                          name="sum_insured"
                          render={({ field }) => {
                            return (
                              <label
                                id="sum_insured_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label for="current_plan" className="label-control">
                        Current Plan
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="current_plan"
                          name="current_plan"
                          render={({ field }) => {
                            return (
                              <label
                                id="current_plan_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label for="od_premium" className="label-control">
                        OD Premium
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="od_premium"
                          name="od_premium"
                          render={({ field }) => {
                            return (
                              <label
                                id="od_premium_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label for="tp_premium" className="label-control">
                        TP Premium
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="tp_premium"
                          name="tp_premium"
                          render={({ field }) => {
                            return (
                              <label
                                id="tp_premium_label"
                                className="border-0 fw-bold"
                              >
                                {field.value !== null && field.value !== "null"
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label for="add_on_premium" className="label-control">
                        Addon Premium
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="add_on_premium"
                          name="add_on_premium"
                          render={({ field }) => {
                            return (
                              <label
                                id="add_on_premium_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label for="stamp_duty" className="label-control">
                        Stamp Duty
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="stamp_duty"
                          name="stamp_duty"
                          render={({ field }) => {
                            return (
                              <label
                                id="stamp_duty_label"
                                className="border-0 fw-bold"
                              >
                                {field.value !== null && field.value !== "null"
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label for="net_premium" className="label-control">
                        Net Premium
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="net_premium"
                          name="net_premium"
                          render={({ field }) => {
                            return (
                              <label
                                id="net_premium_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label for="gst_perc" className="label-control">
                        GST (%)
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="gst_perc"
                          name="gst_perc"
                          render={({ field }) => {
                            return (
                              <label
                                id="gst_perc_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label for="gst_amount" className="label-control">
                        GST Amount
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="gst_amount"
                          name="gst_amount"
                          render={({ field }) => {
                            return (
                              <label
                                id="gst_amount_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label for="gross_premium" className="label-control">
                        Gross Premium
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="gross_premium"
                          name="gross_premium"
                          render={({ field }) => {
                            return (
                              <label
                                id="gross_premium_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? Number(field.value).toFixed(4)
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {role && role !== null && role == "copsdashboard" && (
                    <>
                      <div className="col-12 border-bottom mb-2">
                        <h6 className="text-primary">Brokerage Details</h6>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label
                            for="od_brokerage_perc"
                            className="label-control"
                          >
                            OD Brokerage %
                          </label>
                          <div className="my-1">
                            <Controller
                              className="form-control"
                              control={control}
                              id="od_brokerage_perc"
                              name="od_brokerage_perc"
                              render={({ field }) => {
                                return (
                                  <label
                                    id="od_brokerage_perc_label"
                                    className="border-0 fw-bold"
                                  >
                                    {field.value !== null &&
                                      field.value !== "null"
                                      ? field.value
                                      : "-"}
                                  </label>
                                );
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label
                            for="od_brokerage_amount"
                            className="label-control"
                          >
                            OD Brokerage Amount
                          </label>
                          <div className="my-1">
                            <Controller
                              className="form-control"
                              control={control}
                              id="od_brokerage_amount"
                              name="od_brokerage_amount"
                              render={({ field }) => {
                                return (
                                  <label
                                    id="od_brokerage_amount_label"
                                    className="border-0 fw-bold"
                                  >
                                    {field.value !== null &&
                                      field.value !== "null"
                                      ? field.value
                                      : "-"}
                                  </label>
                                );
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label
                            for="tp_brokerage_perc"
                            className="label-control"
                          >
                            TP Brokerage %
                          </label>
                          <div className="my-1">
                            <Controller
                              className="form-control"
                              control={control}
                              id="tp_brokerage_perc"
                              name="tp_brokerage_perc"
                              render={({ field }) => {
                                return (
                                  <label
                                    id="tp_brokerage_perc_label"
                                    className="border-0 fw-bold"
                                  >
                                    {field.value !== null &&
                                      field.value !== "null"
                                      ? field.value
                                      : "-"}
                                  </label>
                                );
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label
                            for="tp_brokerage_amount"
                            className="label-control"
                          >
                            TP Brokerage Amount
                          </label>
                          <div className="my-1">
                            <Controller
                              className="form-control"
                              control={control}
                              id="tp_brokerage_amount"
                              name="tp_brokerage_amount"
                              render={({ field }) => {
                                return (
                                  <label
                                    id="tp_brokerage_amount_label"
                                    className="border-0 fw-bold"
                                  >
                                    {field.value !== null &&
                                      field.value !== "null"
                                      ? field.value
                                      : "-"}
                                  </label>
                                );
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label
                            for="total_brokerage_amount"
                            className="label-control"
                          >
                            Total Brokerage Amount
                          </label>
                          <div className="my-1">
                            <Controller
                              className="form-control"
                              control={control}
                              id="total_brokerage_amount"
                              name="total_brokerage_amount"
                              render={({ field }) => {
                                return (
                                  <label
                                    id="total_brokerage_amount_label"
                                    className="border-0 fw-bold"
                                  >
                                    {field.value !== null &&
                                      field.value !== "null"
                                      ? field.value
                                      : "-"}
                                  </label>
                                );
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label for="reward_perc" className="label-control">
                            Reward %
                          </label>
                          <div className="my-1">
                            <Controller
                              className="form-control"
                              control={control}
                              id="reward_perc"
                              name="reward_perc"
                              render={({ field }) => {
                                return (
                                  <label
                                    id="reward_perc_label"
                                    className="border-0 fw-bold"
                                  >
                                    {field.value !== null &&
                                      field.value !== "null"
                                      ? field.value
                                      : "-"}
                                  </label>
                                );
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label for="reward_amount" className="label-control">
                            Reward Amount
                          </label>
                          <div className="my-1">
                            <Controller
                              className="form-control"
                              control={control}
                              id="reward_amount"
                              name="reward_amount"
                              render={({ field }) => {
                                return (
                                  <label
                                    id="reward_amount_label"
                                    className="border-0 fw-bold"
                                  >
                                    {field.value !== null &&
                                      field.value !== "null"
                                      ? field.value
                                      : "-"}
                                  </label>
                                );
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label
                            for="enhance_brokerage_perc"
                            className="label-control"
                          >
                            Enhance Brokerage %
                          </label>
                          <div className="my-1">
                            <Controller
                              className="form-control"
                              control={control}
                              id="enhance_brokerage_perc"
                              name="enhance_brokerage_perc"
                              render={({ field }) => {
                                return (
                                  <label
                                    id="enhance_brokerage_perc_label"
                                    className="border-0 fw-bold"
                                  >
                                    {field.value !== null &&
                                      field.value !== "null"
                                      ? field.value
                                      : "-"}
                                  </label>
                                );
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label
                            for="enhance_brokerage_amount"
                            className="label-control"
                          >
                            Enhance Brokerage Amount
                          </label>
                          <div className="my-1">
                            <Controller
                              className="form-control"
                              control={control}
                              id="enhance_brokerage_amount"
                              name="enhance_brokerage_amount"
                              render={({ field }) => {
                                return (
                                  <label
                                    id="enhance_brokerage_amount_label"
                                    className="border-0 fw-bold"
                                  >
                                    {field.value !== null &&
                                      field.value !== "null"
                                      ? field.value
                                      : "-"}
                                  </label>
                                );
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label
                            for="net_brokerage_amount"
                            className="label-control"
                          >
                            Net Brokerage Amount
                          </label>
                          <div className="my-1">
                            <Controller
                              className="form-control"
                              control={control}
                              id="net_brokerage_amount"
                              name="net_brokerage_amount"
                              render={({ field }) => {
                                return (
                                  <label
                                    id="net_brokerage_amount_label"
                                    className="border-0 fw-bold"
                                  >
                                    {field.value !== null &&
                                      field.value !== "null"
                                      ? field.value
                                      : "-"}
                                  </label>
                                );
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  <div className="col-12 border-bottom mb-2">
                    <h6 className="text-primary">Payment Details </h6>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div class="form-group has-search">
                      <label for="payment_date" class="form-label">
                        Payment Date
                      </label>
                      {/* <span class="fa fa-calendar form-control-feedback"></span> */}
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="payment_date"
                          name="payment_date"
                          render={({ field }) => {
                            return (
                              <label
                                id="payment_date_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? moment(field.value).format("DD-MM-YYYY")
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label for="paid_through" className="label-control">
                        Paid Through
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="paid_through"
                          name="paid_through"
                          render={({ field }) => {
                            return (
                              <label
                                id="paid_through_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 mb-3">
                    <div className="form-group">
                      <label for="cops_remark" className="label-control">
                        COPS Remark
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="cops_remark"
                          name="cops_remark"
                          render={({ field }) => {
                            return (
                              <label
                                id="cops_remark_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 border-bottom mb-2">
                    <h6 className="text-primary">Document Details </h6>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label for="policy_doc_status" className="label-control">
                        Policy Document Status
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="policy_doc_status"
                          name="policy_doc_status"
                          render={({ field }) => {
                            return (
                              <label
                                id="policy_doc_status_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label for="brokers_details" className="label-control">
                        Broker Details
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="brokers_details"
                          name="brokers_details"
                          render={({ field }) => {
                            return (
                              <label
                                id="brokers_details_label"
                                className="border-0 fw-bold"
                              >
                                {field.value &&
                                  field.value !== null &&
                                  field.value !== "null"
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {docStatus === "Yes" && (
                    <>
                      <div className="col-12 mt-1">
                        <div className="row">
                          {document && document.length > 0 ? (
                            document.map((objLink, index) => (
                              <>
                                <div className="col-12 col-md-4 col-xl-3">
                                  <div className="card shadow bg-light rounded mb-1 ">
                                    <div className="card-body d-flex justify-content-between py-1">
                                      <a
                                        className="primary"
                                        onClick={() => {
                                          dispatch(actionDownload({ dmsIds: [objLink?.id] }));
                                        }}
                                      >
                                        {objLink.actual_uploaded_file_name}
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </>
                            ))
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>

              {/* <div className="form-actions border-0 float-none mt-1">
                <button
                  className="btn btn-outline-secondary mr-1 shadow round text-uppercase"
                  onClick={(event) => {
                    event.preventDefault();
                    navigate(-1);
                  }}
                >
                  Close
                </button>
              </div> */}
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default PolicyDetails;
